import { getShopifyProductList } from 'lowcode/apis/getShopifyProductList';
import { useEffect, useState } from 'react';

export const usePrice = (locale = 'eu') => {
    const [price, setPrice] = useState(0);
    const [compareAtPrice, setCompareAtPrice] = useState(0);

    const variantId = {
        eu: '50510963016023',
        uk: '50839891116371',
        de: '55835416199549',
        fr: '50473938420059',
        it: '55029709537656',
        es: '50473803383131',
    };

    useEffect(() => {
        const getPrice = async () => {
            const res = await getShopifyProductList(locale, [variantId[locale as keyof typeof variantId]]);
            const target = res.find((resItem: any) => resItem.variantId === variantId[locale as keyof typeof variantId]);
            if (target) {
                setPrice(target.price);
                setCompareAtPrice(target.compareAtPrice);
            }
        };
        getPrice();
    }, []);

    return { price, compareAtPrice };
};
